import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from "@angular/core";

@Injectable()

export class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
     return 1;
   }

   override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    return ['DOM', 'LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB'];
   }
}